/* ============================================================
   HYRALUXE wishlist page.

   Saved handles come from localStorage; each row is hydrated from the product's
   own .js endpoint, so price, image and availability are the live ones and a
   product that has since been unpublished drops out rather than rendering a
   dead card.
   ============================================================ */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);

  const wrap = $('#wl-wrap');
  if (!wrap) return;

  const countEl = $('#wl-count');
  const foot = $('.wl-foot');
  const WKEY = 'hyraluxe:wishlist';

  const get = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (err) { return []; } };
  const set = list => localStorage.setItem(WKEY, JSON.stringify(list));

  const money = cents => (window.hyraMoney ? window.hyraMoney(cents) : '₹' + Math.round(cents / 100));
  const esc = s => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  const HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.5C7 16.5 3 13.3 3 9.3 3 6.4 5.2 4 8 4c1.6 0 3.1.8 4 2 .9-1.2 2.4-2 4-2 2.8 0 5 2.4 5 5.3 0 4-4 7.2-9 11.2Z"/></svg>';

  const EMPTY =
    '<div class="cart-empty">' +
      '<p class="serif" style="font-size:20px;">YOUR WISHLIST IS EMPTY</p>' +
      '<p>Save the sarees you love and come back to them anytime.</p>' +
      '<a class="btn btn--full" href="/collections/all">EXPLORE SAREES</a>' +
    '</div>';

  const rowHTML = p => {
    const v = p.variants && p.variants[0];
    let price = '<span class="price-now">' + money(p.price) + '</span>';
    if (p.compare_at_price && p.compare_at_price > p.price) {
      const off = Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price);
      price += '<span class="price-mrp">' + money(p.compare_at_price) + '</span>' +
               '<span class="price-off">' + off + '% OFF</span>';
    }
    const img = p.featured_image ? p.featured_image + '&width=200' : '';
    const soldOut = !p.available;
    return '<div class="prow wl">' +
      '<a class="prow__img" href="/products/' + esc(p.handle) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="80" height="100" loading="lazy">' : '') +
      '</a>' +
      '<div class="prow__body">' +
        '<a class="prow__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
        '<div class="prow__price">' + price + '</div>' +
      '</div>' +
      '<div class="prow__actions">' +
        '<button class="prow__remove active" data-wish="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist">' + HEART + '</button>' +
        (soldOut
          ? '<button class="btn btn--sm" disabled>SOLD OUT</button>'
          : '<button class="btn btn--sm" data-add="' + (v ? v.id : '') + '">ADD TO BAG</button>') +
      '</div>' +
    '</div>';
  };

  /* One fetch per saved handle, in parallel; anything that 404s is pruned from
     the stored list so the page does not keep asking for it. */
  const load = async () => {
    const list = get();
    if (countEl) countEl.textContent = list.length;
    if (foot) foot.hidden = list.length === 0;

    if (!list.length) { wrap.innerHTML = EMPTY; return; }

    const results = await Promise.all(list.map(h =>
      fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(r => (r.ok ? r.json() : null))
        .catch(() => null)
    ));

    const alive = [];
    const products = [];
    results.forEach((p, i) => { if (p) { alive.push(list[i]); products.push(p); } });

    if (alive.length !== list.length) set(alive);

    if (countEl) countEl.textContent = alive.length;
    if (foot) foot.hidden = alive.length === 0;
    wrap.innerHTML = alive.length ? products.map(rowHTML).join('') : EMPTY;
  };

  /* MOVE ALL TO BAG — a move, not a copy: the wishlist ends up empty. */
  const moveAll = async () => {
    const list = get();
    if (!list.length) { if (window.hyraToast) window.hyraToast('Your wishlist is empty.'); return; }

    const rows = [...wrap.querySelectorAll('[data-add]')].filter(b => b.dataset.add);
    if (!rows.length) { if (window.hyraToast) window.hyraToast('Nothing here is in stock right now.'); return; }

    const items = rows.map(b => ({ id: Number(b.dataset.add), quantity: 1 }));
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) { if (window.hyraToast) window.hyraToast('Could not move those to your bag.'); return; }

    set([]);
    await load();
    if (window.hyraPaintHearts) window.hyraPaintHearts();
    if (window.hyraToast) {
      window.hyraToast(items.length + (items.length === 1 ? ' item moved to bag' : ' items moved to bag'));
    }
    /* let the shared cart code redraw the drawer and the badge */
    document.dispatchEvent(new CustomEvent('cart:needs-refresh'));
  };

  const btn = document.querySelector('[data-move-all]');
  if (btn) btn.addEventListener('click', moveAll);

  document.addEventListener('wishlist:updated', load);
  load();
})();
